var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    attrs: {
      "id": "newPassword",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newPassword"
    }
  }, [_vm._v("New Password")])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "id": "confirmPassword",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirmPassword"
    }
  }, [_vm._v("Confirm Password")])])]), _vm._v(" "), _c('div', {
    staticClass: "reset-button"
  }, [(_vm.validToken && !_vm.resetSuccessful) ? _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v("Reset Password")]) : _vm._e(), _vm._v(" "), (!_vm.validToken || _vm.resetSuccessful) ? _c('button', [_vm._v("Reset Password")]) : _vm._e()]), _vm._v(" "), (!_vm.validToken && !_vm.resetSuccessful) ? _c('div', {
    staticClass: "invalid-token-overlay"
  }, [_c('div', {
    staticClass: "invalid-token"
  }, [_c('h1', [_vm._v("Error")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "invalid-token-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeWindow()
      }
    }
  }, [_vm._v("Exit")])])]) : _vm._e(), _vm._v(" "), (_vm.resetSuccessful) ? _c('div', {
    staticClass: "reset-success-overlay"
  }, [_c('div', {
    staticClass: "reset-success"
  }, [_c('h1', [_vm._v("Password Reset!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "reset-success-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeWindow()
      }
    }
  }, [_vm._v("Exit")])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-text"
  }, [_vm._v("\n\t\t\t\t\tReset password token is invalid or has expired."), _c('br'), _vm._v("\n\t\t\t\t\tPlease try requesting a password reset from the app again.\n\t\t\t\t")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-text"
  }, [_vm._v("\n\t\t\t\t\tYou can now log in with your new password on the"), _c('br'), _vm._v("\n\t\t\t\t\tPerfect Portions App.\n\t\t\t\t")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eaf97ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = ZidX
// module chunks = 1